
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import { ITMGMTLogo } from '@/components/logo/ITMGMTLogo';
import LoginForm from '@/components/auth/LoginForm';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';
import { getSubdomainType } from '@/utils/subdomainUtils';

const Auth: React.FC = () => {
  const [loginAttempts, setLoginAttempts] = React.useState(0);
  const navigate = useNavigate();
  
  // For non-main domains, redirect to appropriate pages
  React.useEffect(() => {
    const subdomainType = getSubdomainType();
    
    if (subdomainType === 'portal') {
      console.log('Portal subdomain detected on Auth page - redirecting to employee portal');
      navigate('/portal', { replace: true });
      return;
    }
    
    if (subdomainType === 'billing') {
      console.log('Billing subdomain detected on Auth page - redirecting to billing dashboard');
      navigate('/billing', { replace: true });
      return;
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Login - IT Management Solutions"
        description="Log in to access IT Management Solutions client portal."
        canonicalUrl="https://itmgmtsol.com/auth"
      />
      <Navbar />
      
      <div className="flex-grow flex items-center justify-center p-6">
        <div className="bg-white rounded-lg shadow-md p-8 border border-gray-100 max-w-md w-full">
          <div className="flex justify-center mb-6">
            <ITMGMTLogo className="h-16" />
          </div>
          
          <h1 className="text-2xl font-bold text-itmgmt-dark-blue mb-6 text-center">Client Portal Login</h1>
          
          <LoginForm 
            loginAttempts={loginAttempts}
            setLoginAttempts={setLoginAttempts}
          />
          
          <div className="mt-6 text-center">
            <p className="text-gray-600 mb-4">Don't have an account yet?</p>
            <Link to="/signup">
              <Button variant="outline" className="w-full flex items-center justify-center">
                <UserPlus className="mr-2" size={18} />
                Sign Up for New Account
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Auth;
